var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8513 4.16941V21.9442H44.7512V4.16941H36.8513ZM35.8638 6.14439H45.7387C46.2841 6.14439 46.7262 6.58651 46.7262 7.13188V41.6941C46.7262 44.9663 44.0735 47.619 40.8012 47.619C37.529 47.619 34.8763 44.9663 34.8763 41.6941V7.13188C34.8763 6.58651 35.3184 6.14439 35.8638 6.14439Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8888 0.219452H47.7137C48.259 0.219452 48.7012 0.661567 48.7012 1.20694V7.13189C48.7012 7.67727 48.259 8.11938 47.7137 8.11938H33.8888C33.3434 8.11938 32.9013 7.67727 32.9013 7.13189V1.20694C32.9013 0.661567 33.3434 0.219452 33.8888 0.219452Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.969 6.58085L26.2483 9.95827C26.7608 10.1448 27.0251 10.7115 26.8385 11.224L15.0176 43.7018C13.8984 46.7767 10.4984 48.3621 7.4235 47.243C4.34858 46.1238 2.76315 42.7238 3.88232 39.6489L15.7033 7.17105C15.8898 6.65856 16.4565 6.39432 16.969 6.58085ZM24.6449 11.4764L17.2214 8.77447L11.7092 23.9192L20.1161 23.9192L24.6449 11.4764Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1395 0.337742L30.1307 5.06613C30.6432 5.25266 30.9074 5.81932 30.7209 6.33181L28.6944 11.8994C28.5079 12.4119 27.9412 12.6762 27.4287 12.4896L14.4376 7.76125C13.9251 7.57472 13.6609 7.00805 13.8474 6.49557L15.8739 0.927938C16.0604 0.415452 16.6271 0.151212 17.1395 0.337742Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.b4bc9e88946c0545dfd90d849274b749.svg";
export { ForwardRef as ReactComponent };